import type { QuizAnswer } from '@ts-assessment/interfaces'
import type { AssessmentTestStore } from './interfaces'

export const actions = {
  setLoading (this: AssessmentTestStore, payload: AssessmentTestStore['loading']): void {
    this.loading = payload
  },
  setCompiling (this: AssessmentTestStore, payload: AssessmentTestStore['compiling']): void {
    this.compiling = payload
  },
  setAnswers (this: AssessmentTestStore, payload: AssessmentTestStore['answers']): void {
    this.answers = payload
  },
  setCurrentAnswer (this: AssessmentTestStore, payload: AssessmentTestStore['answer']): void {
    this.answer = payload
  },
  setCurrentStep (this: AssessmentTestStore, payload: AssessmentTestStore['step']): void {
    this.step = payload
  },
  setHomeStep (this: AssessmentTestStore, payload: AssessmentTestStore['homeStep']): void {
    this.homeStep = payload
  },
  setQuestions (this: AssessmentTestStore, payload: AssessmentTestStore['questions']): void {
    this.questions = payload
  },
  setCurrentQuestion (this: AssessmentTestStore, payload: AssessmentTestStore['question']): void {
    this.question = payload
  },
  setQuestionsTotal (this: AssessmentTestStore, payload: AssessmentTestStore['questionsTotal']): void {
    this.questionsTotal = payload
  },
  setTitle (this: AssessmentTestStore, payload: AssessmentTestStore['title']): void {
    this.title = payload
  },
  setVariant (this: AssessmentTestStore, payload: AssessmentTestStore['variant']): void {
    this.variant = payload
  },
  setComprehension (this: AssessmentTestStore, payload: AssessmentTestStore['comprehension']): void {
    this.comprehension = payload
  },
  setAssessmentTitle (this: AssessmentTestStore, payload: AssessmentTestStore['assessmentTitle']): void {
    this.assessmentTitle = payload
  },
  setAssessmentDescription (this: AssessmentTestStore, payload: AssessmentTestStore['assessmentDescription']): void {
    this.assessmentDescription = payload
  },
  setAnswer (this: AssessmentTestStore, payload: QuizAnswer): void {
    const answers = this.answers
    if (!answers) {
      this.answers = {
        [payload.questionName]: payload,
      }
    } else {
      this.answers = {
        ...answers,
        [payload.questionName]: payload,
      }
    }
  },
}
